export const COLUMNS_NAME = {
  SUPPLIER: "Supplier",
  SUPPLIER_TOTAL_OUTSTANDNG: "Supplier Total Out.",
  TOTAL_SUPPLIER_OUTSTANDING: "Total Supplier Out.",
  ADDRESS: "Address",
  TEL: "Tel ",
  INVOICE_NUMBER: "Invoice Code",
  REMARKS: "Remarks",
  GRN_NUMBER: "GRN Number",
  INVOICE_DATE: "Date",
  GRN_DATE: "GRN Date",
  LOCATION: "Location",
  CODE: "Code",
  DESCRIPTION: "Description",
  BARCODE: "Barcode",
  UNIT_PRICE: "U.Price",
  QUANTITY: "QTY",
  FREE_QUANTITY: "Free QTY",
  DISCOUNT_PERCENTAGE: "Dis(%) ",
  DISCOUNT_RE_PRICE: "Dis.Re.Pr ",
  DISCOUNT_AMOUNT: "Dis(Rs)",
  SUM: "Sum",
  SUB_TOTAL: "GROSS TOTAL",
  SPCLDIS: "Special Discount",
  BILL_DISCOUNT_PERCENTAGE: "Bill Discount",
  DISCOUNT_FOR_TOTAL_BILL: "Bill Discount Total",
  PAYMENT_TYPE_SUMMARY: "Payment Type Summary",
  BILL_DISCOUNT_AMOUNT: "Bill Discount (Rs)",
  TOTAL: "Total",
  TOTAL_TWC: "Total / TWC",
  BILL_TOTAL: "Bill Total",
  INVOICE_TOTAL: "Invoice Total",
  RECEIVED_BY: "Received by",
  CHECKED_BY: "Checked by",
  AUTHERIZED_SIGNATURE: "Authorized Signature",
  RECEIPT_CODE: "Receipt Code",
  DATE: "Date",
  PAYEMENT_TYPE: "Payment Type",
  AMOUNT: "Amount",
  CHEQUE_NO: "Cheque No",
  BANK_NAME: "Bank Name",
  BRANCH_CODE: "Branch Code",
  DEPOSIT_DATE: "Deposit Date",
  CARD_NO: "Card No",
  REFERANCE_NO: "Referance No",
  SETTELED_AMOUNT: "Settle Amt",
  TOTAL_AMOUNT: "Total Amt",
  OUTSTANDING: "Outstanding",
  VOUCHER_NO: "Voucher No",
  CUSTOMER_NAME: "Customer",
  OVERPAYMENT: "Over Payment",
  CHEQUE_RETURN_AMOUNT: "Cheque Return Amount",
  QUOTATION_NO: "Quatation No :",
  ORDER_NO: "Order No :",
  SALESREP: "Sales Rep",
  RETURNAMOUNT: "Return Amount",
  CREDITAMOUNT: "Credit Amount",
  LAST_TOTAL: "TOTAL",
  TOTAL_BILL: "TOTAL",
  LINE_TOTAL: "Line Total",
  LINE_TOTAL_DIS: "Line Total Discount",
  DISCOUNT_TOTAL: "Discount Total",
  DISCOUNT_ADJ_FOR_CARD: "Discount Reverted For Card",
  BILL_TOTAL_DISCOUNT: "Bill-Total Discount",
  TOTAL_DISCOUNT: "Total Discount",
  RETURN_NO: "Return No",
  RETURN_DATE: "Return Date",
  PREPAIRED_BY: "Prepared by",
  CUSTOMER_CODE: "Customer Code",
  DISCOUNT: "Dis",
  PAYID_AMOUNT: "NET AMOUNT",
  FINAL_AMOUNT: "Final Amount",
  NAME: "Name",
  TYPE: "Type",
  CATEGORY: "Category",
  LOCATION_CODE: "Location Code",
  BILL_DISCOUNT: "Bill Discount",
  LINE_DISCOUNT: "Line Discount",
  RETAIL_PRICE: "Ret.Pr",
  RETAIL_SUM: "Ret.sum",
  COST_SUM: "Cost.sum",
  COST_PRICE: "Co.Pr",
  DEBIT_BALANCE: "Debit Balance",
  RETrUN_CODE: "Return Code",
  FROM: "From ",
  TO: "To ",
  VEHICLE_NO: "Vehicle No:",
  VEHICLE_TYPE: "Vehicle Type:",
  VEHICLE_BRAND: "Vehicle Brand:",
  SERIVE_PACK: "Service Pack",
  METER_READING: "Current Meter Reading",
  PAYMENT_RECIEVED: "Payment Received",
  BALANCE_GIVEN: "Balance Given",
  CUSTOMER_ACCEPTANCE: "Customer Acceptance",
  PRE_OUTSTANDING: "Pre-Oustanding",
  SETTLED_TOTAL: "Settled Total",
  PO_NUMBER: "P.O Number",
  WARRANTY_PERIOD: "Warranty",
  CUSTOM_CODE: "Custom Code",
  REMAINING_QUNATITY: "Remaining Quantity",
  REFEREES: "Referees",
  UNIT_SOLD_PRICE: "Sold Price",
  ACC_TRANSACTION_CODE: "Transection Code",
  ACC_TRANSACTION_TYPE: "Transection Type",
  CREDIT_OR_DEBIT: "Credit or Debit",
  NEXT_SERVICE_DATE: "Next Service Date",
  NEXT_SERVICE_KM: "Next Service KM",
  TOTAL_OUTSTANDING: "Total Outstanding",
  DEBIT: "Debit (+)",
  CREDIT: "Credit (-)",
  BALANCE: "Balance",
  SALESREP_CODE: "Sales Rep Code",
  ROUT_NAME: "Route Name",
  SERIES_CODE: "Series",
  TRANSACTION_TYPE: "Transection Type",
  ENTRY_TYPE: "Entry Type",
  LEDGER_TYPE: "Ledger Type",
  TRANSACTION_MODE: "Transection Mode",
  TRANSACTION_NAME: "Transection Name",
  CHEQU_RETURN: "Cheque Return",
  CASH_AMOUNT: "Cash Amount",
  CHEQUE_AMOUNT: "Cheque Amount",
  REFERANCE_NAME: "Referance Name",
  STOCK_IN_TYPE: "Stock in type",
  BATCH_NO: "Batch No",
  EXPENSE_CATEGORY: "Expense Category",
  EXPENSE_TYPE: "Expanse Type",
  ITEM_CODE: "Item Code",
  PREVIOS_OUTSTANDING: "Previous Outtstanding",
  WHOLESALE_PRICE: "W/S Pr",
  TOTAL_RETAIL_PRICE: "Total.Re.Pr",
  MIN_STOCK: "Min Stock",
  MAX_STOCK: "Max Stock",
  ACCESS: "Access",
  ACTION: "Action",
  SOURSE: "Sourse",
  TOTAL_QUANTITY: "Total QTY",
  CURRENT_LOCATION_QUANTITY: "Current Location QTY",
  TOTAL_IN_COST_PRICE: "Total-Cost",
  USER: "User",
  OUTSTANDING_WITH_CHEQUE_RETURN: "Outstanding With Cheque Return",
  STATUS: "Status",
  ONLINE_TRANSFER: "Online Payment",
  OVER_PAYMENT: "Over payment",
  RETURN_AMOUNT: "Return Amount",
  GRN_TOTAL: "Grn Total",
  RECEIPT_OVERPAYMENT: "Receipt Overpayment",
  CHEQUE_PAYMENT: "Cheque Payment",
  RECEIPT_TOTAL: "Receipt Total",
  ACCES_AMOUNT: "Acces Amount",
  BANK_DEPOSIT: "Bank Deposit",
  CARD_PAYMENT: "Card Payment",
  CASH_PAYMENT: "Cash payment",
  FREEZE_STATUS: "Freeze Status",
  DELIVERED_QTY: "D. QTY",
  DELIVEY_CODE: "Delivery Code",
  STOCK_HOLD: "Stock Hold",
  NUMBER_OF_ITEM: "No of Items",
  NUMBER_OF_QUANTITY: "No Of Qty",
  RETURN_TYPE: "Return Type",
  STOCK_ISSUE_CODE: "Stock Issue Code",
  LOCATION_NAME: "Location Name",
  UNIT: "Unit",
  NOT_APPLICABLE: "Not Applicable",
  EXPIRY_DATE: "Expiry Date",
  MEDICAL_REP: "Supplier Rep",
  VAT: "Vat",
  CASH_PAY: "Cash Pay",
  CARD_FEE: "Card Fee",
  KG: "KG",
  G: "Gram",
  L: "L",
  ML: "Milli Liter",
};
